export const labelMonthMap = [
  'jan_short',
  'feb_short',
  'mar_short',
  'apr_short',
  'may_short',
  'jun_short',
  'jul_short',
  'aug_short',
  'sep_short',
  'oct_short',
  'nov_short',
  'dec_short'
]
